import jsPDF from "jspdf";

const BRAND = {
  green: [22, 163, 74],
  dark: [15, 23, 42],
  slate: [100, 116, 139],
  light: [241, 245, 249],
};

const SERVICE_LABEL = {
  terapia_fisica: "Terapia Fisica",
  rehabilitacion: "Rehabilitacion",
  quiropractica: "Quiropractica",
  terapias_alternativas: "T. Alternativas",
  estetica: "Estetica",
  consulta_general: "Consulta general",
};

const formatDate = (s) => {
  if (!s) return "";
  try {
    const d = new Date(s);
    return d.toLocaleDateString("es-MX", { year: "numeric", month: "short", day: "numeric" });
  } catch { return s; }
};

const setColor = (doc, fn, rgb) => doc[fn](rgb[0], rgb[1], rgb[2]);

const header = (doc, title, subtitle) => {
  setColor(doc, "setFillColor", BRAND.green);
  doc.rect(0, 0, 210, 26, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.text("TERAFIQUIRO Wellness Center", 14, 12);
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Al cuidado de tu cuerpo · Pachuca, Hidalgo", 14, 19);
  doc.setTextColor(15, 23, 42);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(title, 14, 38);
  if (subtitle) {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    setColor(doc, "setTextColor", BRAND.slate);
    doc.text(subtitle, 14, 45);
  }
  doc.setTextColor(15, 23, 42);
};

const footer = (doc) => {
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    setColor(doc, "setTextColor", BRAND.slate);
    doc.setFontSize(8);
    doc.text(
      `TERAFIQUIRO Wellness Center · ${new Date().toLocaleString("es-MX")} · Pagina ${i} de ${pageCount}`,
      14,
      290
    );
  }
};

// -------- Patient history PDF --------
export const exportPatientHistoryPdf = ({ name, phone, email, summary = {}, profile = {}, appointments = [], contacts = [] }) => {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  header(doc, `Historial: ${name || "Paciente"}`, `${phone || ""}${email ? "  ·  " + email : ""}`);

  let y = 56;

  // Profile (tags + notes)
  if (profile.tags?.length || profile.notes) {
    if (profile.tags?.length) {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text("Etiquetas:", 14, y);
      doc.setFont("helvetica", "normal");
      doc.text(profile.tags.join(" · "), 38, y);
      y += 6;
    }
    if (profile.notes) {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text("Notas clinicas:", 14, y);
      y += 5;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      const lines = doc.splitTextToSize(profile.notes, 182);
      doc.text(lines, 14, y);
      y += lines.length * 4 + 4;
    }
    y += 2;
  }

  // Summary stats
  setColor(doc, "setFillColor", BRAND.light);
  doc.roundedRect(14, y, 182, 18, 2, 2, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.setTextColor(15, 23, 42);
  const stats = [
    [`${summary.total_appointments || 0}`, "Citas total"],
    [`${summary.future || 0}`, "Futuras"],
    [`${summary.past || 0}`, "Pasadas"],
    [`${summary.messages || 0}`, "Mensajes"],
  ];
  stats.forEach((s, i) => {
    const x = 14 + i * 45.5 + 5;
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text(s[0], x, y + 7);
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    setColor(doc, "setTextColor", BRAND.slate);
    doc.text(s[1], x, y + 13);
    doc.setTextColor(15, 23, 42);
  });
  y += 24;

  // Appointments
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text(`Citas (${appointments.length})`, 14, y);
  y += 6;

  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  appointments.forEach((a) => {
    if (y > 275) { doc.addPage(); y = 20; }
    doc.setFont("helvetica", "bold");
    doc.text(`${a.date}  ${a.time}`, 14, y);
    doc.setFont("helvetica", "normal");
    setColor(doc, "setTextColor", BRAND.slate);
    doc.text(`${SERVICE_LABEL[a.service] || a.service}  ·  ${a.status || "pending"}`, 60, y);
    doc.setTextColor(15, 23, 42);
    if (a.notes) {
      y += 4;
      const noteLines = doc.splitTextToSize(`"${a.notes}"`, 175);
      doc.setFontSize(8);
      setColor(doc, "setTextColor", BRAND.slate);
      doc.text(noteLines, 18, y);
      y += noteLines.length * 3.5;
      doc.setTextColor(15, 23, 42);
      doc.setFontSize(9);
    }
    y += 6;
  });

  // Messages
  if (contacts.length) {
    if (y > 250) { doc.addPage(); y = 20; }
    y += 4;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text(`Mensajes (${contacts.length})`, 14, y);
    y += 6;
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    contacts.forEach((c) => {
      if (y > 275) { doc.addPage(); y = 20; }
      doc.setFont("helvetica", "bold");
      doc.text(formatDate(c.created_at), 14, y);
      doc.setFont("helvetica", "normal");
      y += 4;
      const lines = doc.splitTextToSize(c.message || "", 182);
      doc.text(lines, 14, y);
      y += lines.length * 4 + 4;
    });
  }

  footer(doc);
  doc.save(`historial-${(name || "paciente").replace(/\s+/g, "_")}.pdf`);
};

// -------- Therapist daily schedule PDF --------
export const exportTherapistDayPdf = ({ therapist, date, appointments }) => {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  header(
    doc,
    `Agenda: ${therapist.name}`,
    `${therapist.role}  ·  ${new Date(date + "T00:00:00").toLocaleDateString("es-MX", { weekday: "long", year: "numeric", month: "long", day: "numeric" })}`
  );

  let y = 58;

  if (appointments.length === 0) {
    doc.setFontSize(11);
    setColor(doc, "setTextColor", BRAND.slate);
    doc.text("Sin citas registradas para este dia.", 14, y);
    footer(doc);
    doc.save(`agenda-${therapist.id}-${date}.pdf`);
    return;
  }

  // Table header
  setColor(doc, "setFillColor", BRAND.green);
  doc.rect(14, y, 182, 8, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text("HORA", 18, y + 5.5);
  doc.text("PACIENTE", 38, y + 5.5);
  doc.text("SERVICIO", 92, y + 5.5);
  doc.text("TELEFONO", 138, y + 5.5);
  doc.text("ESTADO", 174, y + 5.5);
  y += 8;

  doc.setTextColor(15, 23, 42);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);

  appointments.sort((a, b) => (a.time || "").localeCompare(b.time || ""));

  appointments.forEach((a, i) => {
    if (y > 275) {
      doc.addPage();
      y = 20;
    }
    if (i % 2 === 0) {
      setColor(doc, "setFillColor", BRAND.light);
      doc.rect(14, y, 182, 8, "F");
    }
    doc.setFont("helvetica", "bold");
    doc.text(a.time || "—", 18, y + 5.5);
    doc.setFont("helvetica", "normal");
    doc.text((a.name || "").slice(0, 32), 38, y + 5.5);
    doc.text((SERVICE_LABEL[a.service] || a.service || "").slice(0, 24), 92, y + 5.5);
    doc.text(a.phone || "—", 138, y + 5.5);
    doc.text(a.status || "pending", 174, y + 5.5);
    y += 8;
    if (a.notes) {
      const noteLines = doc.splitTextToSize(`Notas: ${a.notes}`, 178);
      doc.setFontSize(8);
      setColor(doc, "setTextColor", BRAND.slate);
      doc.text(noteLines, 18, y + 4);
      y += noteLines.length * 3.5 + 2;
      doc.setTextColor(15, 23, 42);
      doc.setFontSize(9);
    }
  });

  // Summary at the bottom
  if (y > 260) { doc.addPage(); y = 20; }
  y += 6;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text(`Total: ${appointments.length} cita${appointments.length === 1 ? "" : "s"}`, 14, y);

  footer(doc);
  doc.save(`agenda-${therapist.id}-${date}.pdf`);
};
